module.exports = __webpack_public_path__ + "233e6cceff34bbf8b729d9cbbbd8aaed.svg";